// True when amount is a usable price ('' / null / undefined / NaN / non-numeric are not).
export const isValidPrice = amount =>
  amount !== '' &&
  amount !== null &&
  amount !== undefined &&
  Number.isFinite(parseFloat(amount));

export const formatPrice = (amount, removeDecimals) => {
  if (!isValidPrice(amount)) {
    return '';
  }

  const currencyFormatter = new Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency: 'GBP',
    maximumFractionDigits: removeDecimals ? 0 : 2,
  });

  return currencyFormatter.format(parseFloat(amount));
};
